const errorCode = {
    '401': '认证失败，无法访问系统资源',
    '403': '当前操作没有权限',
    '404': '访问资源不存在',
    'default': '系统未知错误，请反馈给管理员',
    // 'url': 'https://sdk.xinrong88.com/manage' // 新欣荣服务器
    // 'url': 'https://sdk.youyu.art/manage' // 有鱼正式服务器
    // 'url': 'http://10.10.80.23:8099/manage' // 俊勇本地服务器
    // 'url': 'http://127.0.0.1:8099/manage' // 后端本地服务器

    // 'url': 'http://10.10.80.106:8099/manage' //后台本地服务器
    // 'url': 'https://sdktest.cmge.com/manage' // 测试服务器
    // 'url': 'https://hwsdkapi-test.cmge.com/manage' // 海外测试服务器
    // 'url': 'https://sdkapi-mg.cmge.com/manage' //正式服务器
    'url': process.env.SDK_API_URL || 'https://hwsdkapi-mg.cmge.com/manage' // 海外正式服务器

    // 'url': 'https://sdkapi.zhenyouquyouxi.com/manage' // 真有趣服务器
    // 'url': 'https://sdkmg.coolthink.cn/manage' // 静思服务器
}

export default errorCode



// WEBPACK FOOTER //
// ./src/utils/errorCode.js